<nav class="flex items-center gap-3 overflow-auto">
  <ng-content select="vs-breadcrumbs-item[slot='before']"></ng-content>
  <vs-breadcrumbs-item *ngFor="let item of config?.items" [config]="item"></vs-breadcrumbs-item>
  <ng-content select="vs-breadcrumbs-item"></ng-content>
</nav>
